import * as React from 'react';
import {useCallback, useEffect, useMemo} from 'react';
import {Alert, AlertTitle, Typography, Box, Link} from '@mui/material';
import {useAuth} from 'react-oidc-context';
import {getSubdomain} from '../../utils/utils';
import {SVGIcon} from '../../components/x2bim_utility_components.jsx';
import {useNavigate, useSearchParams} from "react-router-dom";
import {getAvailableIDPs} from "../../App.tsx";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {InfoOutlined} from "@mui/icons-material";


const LoginButton = ({clickFn, styles, icon, text, textStyles, testid}) => {

    return (
        <Box data-testid={testid} onClick={clickFn} sx={{
            cursor: "pointer",
            marginY: 2,
            borderRadius: 1,
            display: "flex",
            height: 50,
            alignItems: "center",
            justifyContent: "center", ...styles
        }}>
            <SVGIcon sx path={icon} height={32}/> <Typography sx={{ml: 2}} variant='h7'> <Box
            sx={{fontWeight: 'bold', m: 1, textTransform: "uppercase", ...textStyles}}>{text}</Box></Typography>
        </Box>
    )
}

const IdpLoginButton = ({idp, onClick}) => {
    switch (idp) {
        case "AZRHB":
            return <LoginButton testid={`login-container-idp-${idp}`}
                                styles={{background: "#E2001A"}} textStyles={{color: "#fff"}}
                                clickFn={onClick}
                                icon="/public/images/svg_icons/rhaebahn-de.svg"/>
        case "AZDBEC":
            return <LoginButton testid={`login-container-idp-${idp}`} styles={{border: "1px solid"}}
                                clickFn={onClick}
                                textStyles={{fontFamily: "DB Sans Regular"}} text="DB E&C"
                                icon="/public/images/svg_icons/ic-db_brand_logo_32.svg"/>
        case "AZIV":
            return <LoginButton testid={`login-container-idp-${idp}`} styles={{background: "#0066FF"}} textStyles={{color: "#fff"}}
                                clickFn={onClick} text="Infraview"
                                icon="/public/images/svg_icons/infraView_logo_icon.svg"/>
        case "AZCFL":
            return <LoginButton testid={`login-container-idp-${idp}`} styles={{background: "#fff"}} textStyles={{color: "#fff"}}
                                clickFn={onClick}
                                icon="/public/images/cfl-logo.png"/>
        case "INFRAVIEW_X2BIM":
            return <LoginButton testid={`login-container-idp-${idp}`} styles={{background: "#0066FF", alignSelf: "center"}} textStyles={{color: "#fff"}}
                                clickFn={onClick}
                                text="Infraview X2BIM"
                                icon="/public/images/svg_icons/infraView_logo_icon.svg"/>
        default:
            return <LoginButton testid={`login-container-idp-${idp}`} styles={{border: "1px solid"}} clickFn={onClick}
                                icon="/public/images/svg_icons/keycloak.svg"/>
    }
}

const LoginContainer = () => {
    const availableIDPs = useMemo(() => getAvailableIDPs(), [])
    const navigate = useNavigate()
    const {signinRedirect} = useAuth()

    const [searchParams] = useSearchParams()
    const returnTo = searchParams.get("returnTo")

    const handleKeyCloakLogin = useCallback((idp) => signinRedirect({
        redirect_uri: `${window.location.origin}/postLogin${returnTo ? `?returnTo=${returnTo}` : ""}`,
        extraQueryParams: {kc_idp_hint: idp}
    }), [returnTo])

    console.log("available idps, login container", availableIDPs)

    useEffect(() => {
        if (availableIDPs.length > 1 || getSubdomain() == null) return
        void handleKeyCloakLogin(availableIDPs[0])
    }, [availableIDPs, handleKeyCloakLogin]);

    return (
        <Dialog
            open={returnTo !== null}
            onClose={() => navigate("/")}
        >
            <DialogContent sx={{maxWidth: 500, display: "flex", flexDirection: "column", alignItems: "stretch"}}>
                <Typography id="transition-modal-title" variant="h5" textAlign="center">
                    <Box sx={{fontWeight: 'bold', fontFamily: "DB Head Black", m: 1, mb: 3}}>
                        Login Options
                    </Box>
                </Typography>
                {!getSubdomain() && <Alert sx={{fontSize: 16}} severity={"error"} icon={<InfoOutlined/>}>
                    <AlertTitle sx={{fontSize: 20}}>Can't find your login option?</AlertTitle>
                    Use the URL assigned to your organisation.<br/>
                    Example Deutsche Bahn: <Link href={"https://db.x2bim.com"}>db.x2bim.com</Link>
                </Alert>}
                {
                    availableIDPs.map(idp => <IdpLoginButton key={idp} idp={idp}
                                                             onClick={() => handleKeyCloakLogin(idp)}/>)
                }
                {!getSubdomain() && <Typography variant="body1" textAlign={"center"}>
                    Want to add your own organisation?
                    Click <Link href={"https://infraview.net/de/unsere-loesungen/planung-bau/x2bim/"}>here</Link> to get more
                    information!
                </Typography>}
            </DialogContent>
        </Dialog>
    )
}

export default LoginContainer